import * as React from "react";
import { Switch, Tooltip, Col, Row } from "antd";
import { SetStateAction, Dispatch, useState, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import FormItem from "antd/lib/form/FormItem";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { IPricingParametersCalculator } from "src/services/interfaces/calculator/IPricingParametersCalculator";
import { PbrInputPercentage } from "src/components/common/PbrInputPercentageCalculator/PbrInputPercentage";

interface IReducedPercentLenderComponent {
  pricingParameters: IPricingParametersCalculator;
  onChange: Dispatch<SetStateAction<Partial<IPricingParametersCalculator>>>;
}

export function ReducedPercentLenderComponent(props: IReducedPercentLenderComponent & FormComponentProps) {
  const [oldReducedPercent, setOldReducedPercent] = useState<number>(undefined);

  useEffect(() => {
    setOldReducedPercent(props.pricingParameters?.reducedPercentLender)
  }, [])

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={24} lg={14}>
        <FormItem label="Reduzir percentual do credor?">
          <Tooltip title={props.pricingParameters?.isReducedPercentLender ? "Informe o percentual da compra do precatório" : "Aquisição de 100% do precatório"}>
            <Switch checkedChildren="Sim" unCheckedChildren="Não" checked={props.pricingParameters?.isReducedPercentLender}
              onChange={e => { props.onChange({ isReducedPercentLender: e, reducedPercentLender: e ? 0.99 : oldReducedPercent }) }}
            />
          </Tooltip>
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={24} lg={10}>
        {props.pricingParameters?.isReducedPercentLender ? (
          <PbrInputPercentage
            name="isReducedPercentLender"
            value={PercentageMask(props.pricingParameters?.reducedPercentLender, 2, 2)}
            style={{ color: "black" }}
            disabled={false}
            placeholder="Percentual Adquirido"
            formItemProps={{ label: "Percentual Adquirido" }}
            formWrapper={props.form}
            rules={[{ required: true, message: "Percentual Adquirido é obrigatório" }]}
            onChange={e => props.onChange({ reducedPercentLender: e })}
          />
        ) : (
            <PbrInput
              name="reducedPercentLender"
              value={"100%"}
              disabled={true}
              style={{ color: "black" }}
              formItemProps={{ label: "Percentual Adquirido" }}
              formWrapper={props.form}
            />
          )}
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/ReducedPercentLenderComponent/ReducedPercentLenderComponent.tsx